import AlternateLogins from './AlternateLogins.component';

export default AlternateLogins;